import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import IssuesIcon from '@atlaskit/icon/core/issues';

import { useContentJiraWorkItems } from '../hooks/useContentJiraWorkItems';
import { useShowJiraWorkItemsPanel } from '../hooks/useShowJiraWorkItemsPanel';

import { DetailRow } from './DetailRow';
import { SubtleLink } from './SubtleLink';
import { InlineRetryError } from './InlineRetryError';

const i18n = defineMessages({
	jiraWorkItems: {
		id: 'details-panel.links-section.jira-work-items-row',
		defaultMessage: 'Jira work items',
		description:
			'Text that appears next to a number indicating the number of Jira work items on specific content (multiple)',
	},
	jiraWorkItem: {
		id: 'details-panel.links-section.jira-work-item-row',
		defaultMessage: 'Jira work item',
		description:
			'Text that appears next to a number indicating the number of Jira work items on specific content (singular)',
	},
});

export const JiraWorkItemsRow = () => {
	const { formatMessage } = useIntl();
	const { data, error, refetch } = useContentJiraWorkItems();
	const { jiraWorkItemsCount } = data;
	const { showJiraWorkItemsPanel } = useShowJiraWorkItemsPanel();

	const handleClickJiraWorkItems = useCallback(() => {
		showJiraWorkItemsPanel();
		// Todo: implement analytics in CBT-4868 (https://hello.jira.atlassian.cloud/browse/CBT-4868)
	}, [showJiraWorkItemsPanel]);

	return jiraWorkItemsCount > 0 || error ? (
		<DetailRow
			itemName={
				jiraWorkItemsCount != 1
					? formatMessage(i18n.jiraWorkItems)
					: formatMessage(i18n.jiraWorkItem)
			}
			icon={<IssuesIcon label="" />}
		>
			{error ? (
				<InlineRetryError error={error} refetch={refetch} />
			) : (
				<SubtleLink onClick={handleClickJiraWorkItems}>{jiraWorkItemsCount}</SubtleLink>
			)}
		</DetailRow>
	) : null;
};
